// extracted by mini-css-extract-plugin
export default {"outer":"Follow_outer__L96M4","meta":"Follow_meta__g--Af"};